var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThetaEdgeNodeWordmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 262.022,
    height: 48,
    viewBox: "0 0 262.022 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.054,
    y1: 0.046,
    x2: 0.979,
    y2: 0.988,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29b3eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21edba"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.045,
    y1: -1.18,
    x2: 1.513,
    y2: 4.244,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1.958,
    y1: -1.39,
    x2: 2.522,
    y2: 2.054,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.477,
    y1: -0.356,
    x2: 4.003,
    y2: 3.568,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.186,
    y1: -2.037,
    x2: 1.281,
    y2: 3.387,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    "data-name": "Group 940",
    transform: "translate(-529.989 -5194.011)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_424",
    "data-name": "Rectangle 424",
    width: 262.022,
    height: 48,
    transform: "translate(529.989 5194.011)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    "data-name": "Group 935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_926",
    "data-name": "Group 926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_925",
    "data-name": "Group 925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_924",
    "data-name": "Group 924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M570.284,5227.274v-12.5h3.08v12.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M585.845,5208.685v7.755h3.532v-7.755h3.081v18.589h-3.081V5219.2h-3.532v8.073h-3.08v-18.589Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M601.752,5227.274v-18.589H609.9v2.709h-5.072v5.1h4.249v2.708h-4.249v5.365h5.152v2.708Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M627.033,5211.394h-3.108v15.88h-3.08v-15.88h-3.107v-2.709h9.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M640.018,5223.132h-3.4l-.664,4.142h-2.974l3.452-18.589h3.877l3.505,18.589h-3.133Zm-.4-2.55-1.3-8.259-1.3,8.259Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_927",
    "data-name": "Group 927"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M570.284,5227.274v-12.5h3.08v12.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M585.845,5208.685v7.755h3.532v-7.755h3.081v18.589h-3.081V5219.2h-3.532v8.073h-3.08v-18.589Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M601.752,5227.274v-18.589H609.9v2.709h-5.072v5.1h4.249v2.708h-4.249v5.365h5.152v2.708Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M627.033,5211.394h-3.108v15.88h-3.08v-15.88h-3.107v-2.709h9.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M640.018,5223.132h-3.4l-.664,4.142h-2.974l3.452-18.589h3.877l3.505,18.589h-3.133Zm-.4-2.55-1.3-8.259-1.3,8.259Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_928",
    "data-name": "Group 928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M570.284,5227.274v-12.5h3.08v12.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M585.845,5208.685v7.755h3.532v-7.755h3.081v18.589h-3.081V5219.2h-3.532v8.073h-3.08v-18.589Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M601.752,5227.274v-18.589H609.9v2.709h-5.072v5.1h4.249v2.708h-4.249v5.365h5.152v2.708Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M627.033,5211.394h-3.108v15.88h-3.08v-15.88h-3.107v-2.709h9.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M640.018,5223.132h-3.4l-.664,4.142h-2.974l3.452-18.589h3.877l3.505,18.589h-3.133Zm-.4-2.55-1.3-8.259-1.3,8.259Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M570.284,5227.274v-12.5h3.08v12.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M585.845,5208.685v7.755h3.532v-7.755h3.081v18.589h-3.081V5219.2h-3.532v8.073h-3.08v-18.589Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M601.752,5227.274v-18.589H609.9v2.709h-5.072v5.1h4.249v2.708h-4.249v5.365h5.152v2.708Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M627.033,5211.394h-3.108v15.88h-3.08v-15.88h-3.107v-2.709h9.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M640.018,5223.132h-3.4l-.664,4.142h-2.974l3.452-18.589h3.877l3.505,18.589h-3.133Zm-.4-2.55-1.3-8.259-1.3,8.259Z",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M570.274,5211.394h-3.107v-2.709h9.295v2.709h-6.188Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M570.274,5216.5h-3.107V5213.8h9.295v2.708h-6.188Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    "data-name": "Group 936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M656.986,5227.268v-18.55h8.135v2.7H660.06v5.088h4.24v2.7h-4.24v5.354H665.2v2.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    d: "M680.749,5212.64v10.705c0,2.81-1.855,3.923-4.664,3.923h-4.743v-18.55h4.743C678.894,5208.718,680.749,5209.831,680.749,5212.64Zm-4.769-1.22h-1.564v13.146h1.564c1.006,0,1.7-.372,1.7-1.7v-9.752C677.676,5211.792,676.986,5211.42,675.98,5211.42Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    d: "M696.694,5223.558c0,2.861-1.855,3.923-4.664,3.923h-.211c-2.81,0-4.665-1.035-4.665-3.923v-11.13c0-2.756,1.855-3.923,4.665-3.923h.211c2.809,0,4.664,1.167,4.664,3.923v2.65h-3.075V5212.9c0-1.326-.688-1.7-1.7-1.7s-1.7.37-1.7,1.7v10.176c0,1.326.69,1.7,1.7,1.7s1.7-.37,1.7-1.7v-2.756h-1.8v-2.6h4.875Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    d: "M703.152,5227.268v-18.55h8.136v2.7h-5.062v5.088h4.24v2.7h-4.24v5.354h5.141v2.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    d: "M725.717,5227.268v-18.55h3.074l3.9,11.473v-11.473H735.5v18.55h-2.915l-4.054-12.058v12.058Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    d: "M746.671,5208.5h.211c2.81,0,4.665,1.113,4.665,3.923v11.13c0,2.809-1.855,3.923-4.665,3.923h-.211c-2.809,0-4.664-1.114-4.664-3.923v-11.13C742.007,5209.592,743.862,5208.5,746.671,5208.5Zm.106,16.272c1.007,0,1.7-.37,1.7-1.7V5212.9c0-1.326-.689-1.7-1.7-1.7s-1.7.37-1.7,1.7v10.176C745.081,5224.407,745.77,5224.777,746.777,5224.777Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    d: "M767.466,5212.64v10.705c0,2.81-1.855,3.923-4.665,3.923h-4.744v-18.55H762.8C765.611,5208.718,767.466,5209.831,767.466,5212.64Zm-4.771-1.22h-1.564v13.146H762.7c1.007,0,1.7-.372,1.7-1.7v-9.752C764.391,5211.792,763.7,5211.42,762.7,5211.42Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M773.975,5227.268v-18.55h8.136v2.7h-5.062v5.088h4.241v2.7h-4.241v5.354h5.142v2.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_938",
    "data-name": "Group 938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_937",
    "data-name": "Group 937"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M554.989,5231.2h-13.84l-1.34-1.339V5206.1l1.34-1.34h13.84l1.339,1.34v23.766Zm-12.5-2.678h11.161v-21.088H542.488Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_425",
    "data-name": "Rectangle 425",
    width: 8.177,
    height: 2.679,
    transform: "translate(543.98 5214.25)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_426",
    "data-name": "Rectangle 426",
    width: 2.679,
    height: 4.219,
    transform: "translate(546.729 5220.412)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_427",
    "data-name": "Rectangle 427",
    width: 2.679,
    height: 3.702,
    transform: "translate(546.729 5211.5)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_428",
    "data-name": "Rectangle 428",
    width: 8.177,
    height: 2.679,
    transform: "translate(543.98 5219.202)",
    fill: "url(#linear-gradient-5)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThetaEdgeNodeWordmark);
export default __webpack_public_path__ + "static/media/theta-edge-node-wordmark.063f83c76e2311d07d0924ee1c9c7076.svg";
export { ForwardRef as ReactComponent };